import { IconImage } from '@/core/features';

export default function MapTileIcon({ iconSize, iconUrl }: { iconSize: number; iconUrl: string }) {
    return (
        <span
            className={'shrink-0 self-start'}
            /* eslint-disable-next-line no-inline-styles/no-inline-styles */
            style={{ maxHeight: 0 }}
        >
            <IconImage
                alt={'map-tile-icon'}
                height={iconSize}
                url={iconUrl}
                width={iconSize}
            />
        </span>
    );
}
